import { useCallback, useState } from 'react'
import * as Sentry from '@sentry/react'
import { App } from 'antd'
import { useDispatch } from 'react-redux'
// import { removeToken } from '@/helpers/tokenUtils'
import { setUpdateUser } from '@/store/user'
import { setAccessToken, setRefreshToken } from '@/store/auth'
import { useQueryClient } from '@tanstack/react-query'

type IMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'OPTIONS'

export const useHttp = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<string | null>(null)
  const [statusCode, setStatusCode] = useState<number | null>(null)
  const [requestMethod, setRequestMethod] = useState<string | null>(null)
  const { message } = App.useApp()
  const queryClient = useQueryClient()
  const dispatch = useDispatch()

  async function request<T>(
    url: string,
    method: IMethod = 'GET',
    body: any = null,
    headers: HeadersInit = {},
    isFile = false,
    mode?: 'cors' | 'same-origin',
    credentials?: 'omit' | 'same-origin' | 'include'
  ) {
    setLoading(true)
    if (body && !isFile) {
      body = JSON.stringify(body)
      headers['Content-Type'] = 'application/json'
    }

    const timeout = setTimeout(() => {
      window.location.reload()
    }, 120_000)

    try {
      const response = await fetch(url, { method, body, headers, mode, credentials })

      if (!(response.status === 200 || response.status === 201)) {
        setStatusCode(response.status)
        setRequestMethod(method)
      }

      if (response.status === 401) {
        // dispatch(setAccessToken(getCookie('access_token')))
        // dispatch(setRefreshToken(getCookie('refresh_token')))
        return dispatch(setAccessToken(null))
      }

      let data
      try {
        data = (await response.json()) as T
      } catch (error) {
        console.error(error)
      }

      if (!response.ok) {
        setErrors(response.statusText)
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw { data, status: response.status, statusText: response.statusText, method }
      }

      return { data, status: response.status, method }
    } catch (e) {
      Sentry.captureException(e)
      // Sentry.captureMessage('useHttp')

      if (e.status === 401 && e.data.message === 'Deleted JWT') {
        message.error('Вы не можете пользоваться системой')
        // await removeToken()
        dispatch(setUpdateUser(null))
        dispatch(setAccessToken(null))
        dispatch(setRefreshToken(null))
      } else {
        setErrors(e.message)
        throw e
      }
    } finally {
      clearTimeout(timeout)
      setLoading(false)
    }
  }

  const requestMemo = useCallback(request, [dispatch, message, queryClient])

  const clearError = useCallback(() => setErrors(null), [])
  return { loading, request: requestMemo, requestErrors: errors, clearError, statusCode, requestMethod }
}
